import { IContaContato } from "../../../../Interfaces/Geral/Contatos/ContaContato/ContaContatoInterfaces";
import {
    ListarContatoNaoVinculadoService,
    VincularContaContatoService,
} from "../../../../Services/Geral/Contatos/ContaContato/ContaContatoServices";
import { Controller } from "../../../Controller";

export async function VincularContaContatoController(
    requestBody: IContaContato
) {
    return Controller(VincularContaContatoService(requestBody));
}

export async function ListarContatoNaoVinculadoController(
    DS_CONTATO: string,
    IDConta: number
) {
    return Controller(ListarContatoNaoVinculadoService(DS_CONTATO, IDConta));
}
